// Real equipment photos. To swap later: replace files in /frontend/public/photos
// (WebP, max 1600px wide) and update the entries below. Alt text is required.
export const IMAGES = {
  hero: {
    src: "/photos/hero-kubota-jump-wagon.webp",
    alt: {
      en: "Kubota tractor pulling a wagon of red and white jump poles across the show field",
      es: "Tractor Kubota remolcando un vagón con postes de salto rojos y blancos por el campo de exhibición",
    },
  },
  problem: {
    src: "/photos/tractor-deere-pond.webp",
    alt: {
      en: "John Deere tractor with front loader beside the pond on a Florida horse farm",
      es: "Tractor John Deere con cargador frontal junto al estanque en una finca de Florida",
    },
  },
  photos: [
    { key: "tractor-deere-building", group: "tractors", src: "/photos/tractor-deere-building.webp", alt: { en: "Tractor serviced by Equipment Concierge", es: "Tractor reparado por Equipment Concierge" } },
    { key: "tractor-deere-loader", group: "tractors", src: "/photos/tractor-deere-loader.webp", alt: { en: "Tractor serviced by Equipment Concierge", es: "Tractor reparado por Equipment Concierge" } },
    { key: "tractor-kubota-tiller", group: "tractors", src: "/photos/tractor-kubota-tiller.webp", alt: { en: "Tractor serviced by Equipment Concierge", es: "Tractor reparado por Equipment Concierge" } },
    { key: "tractor-bobcat-loader", group: "tractors", src: "/photos/tractor-bobcat-loader.webp", alt: { en: "Tractor serviced by Equipment Concierge", es: "Tractor reparado por Equipment Concierge" } },
    { key: "tractor-kubota-l3130-van", group: "tractors", src: "/photos/tractor-kubota-l3130-van.webp", alt: { en: "Tractor serviced by Equipment Concierge", es: "Tractor reparado por Equipment Concierge" } },
    { key: "utv-kubota-rtv-tow", group: "utvs", src: "/photos/utv-kubota-rtv-tow.webp", alt: { en: "UTV serviced by Equipment Concierge", es: "UTV reparado por Equipment Concierge" } },
    { key: "mower-kubota-shop", group: "mowers", src: "/photos/mower-kubota-shop.webp", alt: { en: "Mower serviced by Equipment Concierge", es: "Cortadora reparada por Equipment Concierge" } },
    { key: "cart-black-canopy", group: "carts", src: "/photos/cart-black-canopy.webp", alt: { en: "Golf cart serviced by Equipment Concierge", es: "Carrito de golf reparado por Equipment Concierge" } },
    { key: "trailer-2horse-white", group: "trailers", src: "/photos/trailer-2horse-white.webp", alt: { en: "Trailer serviced by Equipment Concierge", es: "Trailer reparado por Equipment Concierge" } },
    { key: "trailer-jump-poles", group: "trailers", src: "/photos/trailer-jump-poles.webp", alt: { en: "Trailer serviced by Equipment Concierge", es: "Trailer reparado por Equipment Concierge" } },
    { key: "rv-coleman-fifthwheel", group: "rvs", src: "/photos/rv-coleman-fifthwheel.webp", alt: { en: "RV serviced by Equipment Concierge", es: "RV reparado por Equipment Concierge" } },
    { key: "repair-hydraulics", group: "repairs", src: "/photos/repair-hydraulics.webp", alt: { en: "Equipment repair by Equipment Concierge", es: "Reparación de equipo por Equipment Concierge" } },
    { key: "repair-batteries", group: "repairs", src: "/photos/repair-batteries.webp", alt: { en: "Equipment repair by Equipment Concierge", es: "Reparación de equipo por Equipment Concierge" } },
    { key: "repair-engine-diag", group: "repairs", src: "/photos/repair-engine-diag.webp", alt: { en: "Equipment repair by Equipment Concierge", es: "Reparación de equipo por Equipment Concierge" } },
  ],
};

export const GALLERY_GROUPS = [
  { key: "all", label: { en: "All", es: "Todas" } },
  { key: "tractors", label: { en: "Tractors", es: "Tractores" } },
  { key: "utvs", label: { en: "UTVs & RTVs", es: "UTVs y RTVs" } },
  { key: "mowers", label: { en: "Mowers", es: "Cortadoras" } },
  { key: "carts", label: { en: "Golf Carts", es: "Carritos de Golf" } },
  { key: "trailers", label: { en: "Trailers", es: "Trailers" } },
  { key: "rvs", label: { en: "RVs", es: "RVs" } },
  { key: "repairs", label: { en: "Repairs", es: "Reparaciones" } },
];

export const WA_TEXT = {
  en: "Hi, I need help with my farm equipment.",
  es: "Hola, necesito ayuda con el equipo de mi finca.",
};

export const waHref = (lang) =>
  `https://wa.me/13055825282?text=${encodeURIComponent(WA_TEXT[lang] || WA_TEXT.en)}`;

export const BRAND_GROUPS = [
  {
    key: "tractors",
    label: { en: "Tractors", es: "Tractores" },
    brands: ["Kubota", "John Deere", "Bobcat", "New Holland", "Massey Ferguson", "Mahindra", "Case IH", "Ford"],
  },
  {
    key: "utvs",
    label: { en: "UTVs & RTVs", es: "UTVs y RTVs" },
    brands: ["Kubota RTV", "John Deere Gator", "Polaris Ranger", "Can-Am Defender", "Kawasaki Mule"],
  },
  {
    key: "drags",
    label: { en: "Arena Drags", es: "Rastrillos de Arena" },
    brands: ["DragNfly / Carolina Arena Equipment", "Parma", "Land Pride", "ABI", "Titan"],
  },
  {
    key: "rvs",
    label: { en: "RVs", es: "RVs" },
    brands: ["Coleman", "Winnebago", "Coachmen", "Forest River", "Jayco"],
  },
  {
    key: "carts",
    label: { en: "Golf Carts", es: "Carritos de Golf" },
    brands: ["Club Car", "E-Z-GO", "Yamaha"],
  },
  {
    key: "mowers",
    label: { en: "Mowers", es: "Cortadoras" },
    brands: ["Kubota", "John Deere", "Ferris", "Exmark", "Toro", "Grasshopper"],
  },
  {
    key: "trailers",
    label: { en: "Horse Trailers", es: "Trailers de Caballos" },
    brands: ["4-Star", "Bloomer", "Cimarron", "Exiss", "Sundowner", "Featherlite"],
  },
];

export const FAQ = {
  en: {
    eyebrow: "FAQ",
    title: "Good questions, straight answers.",
    items: [
      {
        q: "Do you repair tractors on the farm in Wellington?",
        a: "Yes — we come to your farm. We handle hydraulics, batteries, engines, electrical and more, fixed where the machine sits. One call: 305-582-5282.",
      },
      {
        q: "Can you sell my old equipment?",
        a: "Yes. We clean it up, sell it and send the cash back to you, with a clear, honest commission. Call for a quote.",
      },
      {
        q: "Do you service horse trailers?",
        a: "Yes — our road-ready checks cover lights, brakes, fans, tires, hitch and electrical so your trailer is ready before the next haul.",
      },
      {
        q: "What areas do you cover?",
        a: "Wellington, Loxahatchee, Jupiter Farms and all of Palm Beach County, plus parts of Martin, Okeechobee and western Broward. Not sure? Just call Nico.",
      },
    ],
  },
  es: {
    eyebrow: "Preguntas frecuentes",
    title: "Buenas preguntas, respuestas directas.",
    items: [
      {
        q: "¿Reparan tractores en la finca en Wellington?",
        a: "Sí — vamos a su finca. Reparamos hidráulica, baterías, motores, electricidad y más, donde está la máquina. Una llamada: 305-582-5282.",
      },
      {
        q: "¿Pueden vender mi equipo usado?",
        a: "Sí. Lo limpiamos, lo vendemos y le enviamos el efectivo, con una comisión clara y honesta. Llame para cotizar.",
      },
      {
        q: "¿Dan servicio a trailers de caballos?",
        a: "Sí — la revisión para la ruta cubre luces, frenos, ventiladores, llantas, enganche y electricidad antes de su próximo viaje.",
      },
      {
        q: "¿Qué zonas cubren?",
        a: "Wellington, Loxahatchee, Jupiter Farms y todo el Condado de Palm Beach, además de partes de Martin, Okeechobee y el oeste de Broward. ¿Dudas? Solo llame a Nico.",
      },
    ],
  },
};
